<template>
  <div class="hidden sm:block">
    <nav class="flex flex-row justify-between space-x-4 mt-2" aria-label="Tabs">
      <button value="highest" @click="selectDataset($event)" :class="[colorPalette.pillText] +' ' + [colorPalette.pillBackground] " class=" selected  tableTab px-3 py-1.5 font-medium text-sm rounded-md">Highest rate</button>
      <button value="lowest" @click="selectDataset($event)" :class="'hover:ring-' + [colorPalette.pillHover]" class=" tableTab hover:ring-2 text-gray-500 hover:text-gray-700 px-3 py-1.5 font-medium text-sm rounded-md">Lowest rate</button>
    </nav>
  </div>
  <div class="-ml-6 -mr-6">
    <table class="mt-4 table-fixed w-full divide-y divide-gray-300">
      <thead>
        <tr>
          <th scope="col" class="py-1 pl-6 pr-1 text-left text-sm font-semibold text-gray-900 ">Product</th>
          <th scope="col" class="py-1 w-44 pl-4 pr-4 text-left text-sm font-semibold text-gray-900 "></th>
          <th scope="col" class="text-right pr-3 py-1 text-left text-sm font-semibold text-gray-900 ">Ratio</th>
        </tr>
      </thead>
      <tbody class="table-fixed divide-y divide-gray-300">
        <table-item v-for="item in items"
                              :key="item.id"
                              :productName="item.productName"
                              :productCode="item.productCode"
                              :imageUrl="item.imageUrl"
                              :amount="(((item.amount)*100).toFixed()) + '%'"> </table-item>
      </tbody>
    </table>
  </div>
</template>

<script setup>

import {defineProps, onMounted, ref} from "vue";
import TableItem from "@/widgetContent/listItems/TableItemWithImage";
import ApiService from "@/services/ApiService";
let apiService = new ApiService;
let props = defineProps({
  update: Number,
  source: String,
  style: Object,
  colorPalette: Object,
  pills: Array,
  type: String,
  hasLongTitle: Boolean
})

let data = ref(null);
let items = ref(null);

onMounted ( async () => {
  let apiData = await apiService.get(props.source);
  data.value = apiData.datasets
  getData(data.value)
    }
)
function selectDataset(e)
{
  e.preventDefault();
  if (! e.target.classList.contains("selected"))
  {
    e.target.classList = "selected px-3 py-1.5 font-medium text-sm rounded-md " + props.colorPalette.pillText + " " + props.colorPalette.pillBackground;
    getSiblings(e.target).forEach(el =>
        el.classList = "text-gray-500 hover:ring-2 hover:text-gray-700 px-3 py-1.5 font-medium text-sm rounded-md "+ 'hover:ring-' + [props.colorPalette.pillHover]
    )
    getData(data.value, e.target.value)
  }
}

function getSiblings(e)
{
  let siblings = [];
  let sibling = e.parentNode.firstChild;
  while (sibling) {
    if (sibling.nodeType === 1 && sibling !== e) {
      siblings.push(sibling);
    }
    sibling = sibling.nextSibling
  }
  return siblings;
}
function getData(data, type = "highest")
{
  items.value = data[type];
}

</script>
